export const bytesToKBWithPrecision = (size) => Math.round(((size + Number.EPSILON) * 100) / 1024) / 100;
export const bytesToMBWithPrecision = (size) => Math.round(((size + Number.EPSILON) * 100) / (1024 * 1024)) / 100;
